(function waitForJQuery(fn) {
  if (window.jQuery) {
    fn(window.jQuery);
  } else {
    setTimeout(function () {
      waitForJQuery(fn);
    }, 50);
  }
})(function ($) {
  $(document).ready(function () {
    // Accordion: open/close filter groups
    $(document).on('click', '.sb-filter .sbf-title', function () {
      var $group = $(this).closest('.sb-filter');
      $group.find('.advanced-filters').toggle('slow');
      $group.toggleClass('active');
    });

    // Toggle main filter panel
    $(document).on('click', '.filter-sidebar .heading', function () {
      $('.sb-filter-wrapper').toggle('slow');
      $('.filter-sidebar').toggleClass('active');
    });

    // Toggle sort dropdown
    $(document).on('click', '.filter-dropdown__label', function () {
      $('.filter-dropdown__select').toggle('slow');
      $('.filter-dropdown').toggleClass('active');
    });

    $('.advanced-filter').each(function () {
      var el = $(this);
      if (el.hasClass('active-filter')) {
        el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
      }
    });

    $('.advanced-filter').on('click', function (e) {
      var el = $(this);
      var group = el.data('group');
      var url = el.find('a').attr('href');
      var clickedLink = $(e.target).closest('a').length > 0;

      if (!url) {
        return;
      }

      // Active filter: allow the remove link to work; navigate if checkbox/checkmark clicked
      if (el.hasClass('active-filter')) {
        if (!clickedLink) {
          e.preventDefault();
          window.location = url;
        }
        return;
      }

      // When "Disable AND in a group" is on, replace any active tag in the same group
      var logic = $('.filter-sidebar').data('logic');
      if (logic) {
        var activeTag = $('.active-filter[data-group="' + group + '"]');
        if (activeTag.length) {
          e.preventDefault();
          var activeHandle = String(activeTag.data('handle') || '');
          if (activeHandle) {
            url = url
              .replace(activeHandle + '+', '')
              .replace('+' + activeHandle, '');
          }
          window.location = url;
          return;
        }
      }

      // Checkbox/checkmark clicks should navigate like the link
      if (!clickedLink) {
        e.preventDefault();
        window.location = url;
      }
    });
  });
});
